var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBxsCartAlt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.457,
    height: 17.387,
    viewBox: "0 0 20.457 17.387",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxs-cart-alt",
    transform: "translate(-3 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    d: "M22.433,6H3V8.046H5.352l3.6,9.9A2.05,2.05,0,0,0,10.875,19.3h8.489V17.251H10.875l-.745-2.046h9.234a1.022,1.022,0,0,0,.94-.62l3.068-7.16A1.021,1.021,0,0,0,22.433,6Z",
    transform: "translate(0 0)",
    fill: "#01499c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    d: "M16.568,28.534A1.534,1.534,0,1,1,15.034,27,1.534,1.534,0,0,1,16.568,28.534Z",
    transform: "translate(-3.34 -6.681)",
    fill: "#01499c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    d: "M25.568,28.534A1.534,1.534,0,1,1,24.034,27,1.534,1.534,0,0,1,25.568,28.534Z",
    transform: "translate(-6.204 -6.681)",
    fill: "#01499c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxsCartAlt);
export default __webpack_public_path__ + "static/media/bxs-cart-alt.57901c34bd103f5aa2116157e91c6359.svg";
export { ForwardRef as ReactComponent };